import { IfcViewer } from '@consigli/facade';
import { type FC } from 'react';

import type { DocumentPaneRenderProps } from '@aecom-ai-engineering/react-components';

interface IfcRendererPaneProps {
  active: boolean;
  src: DocumentPaneRenderProps['src'];
}

const documentViewerSpinner = (
  <div data-ds-document-viewer-status="">
    <span aria-hidden="true" data-ds-document-viewer-spinner="" />
    Loading...
  </div>
);

const IfcRendererPane: FC<IfcRendererPaneProps> = ({ active, src }) => {
  if (!active) return null;

  const fileUrl = typeof src === 'string' ? src : src instanceof URL ? src.href : undefined;
  if (!fileUrl) return null;

  return (
    <div className="h-full w-full">
      <IfcViewer fileUrl={fileUrl} loadingElement={documentViewerSpinner} />
    </div>
  );
};

export function createIfcRenderer() {
  return function IfcRenderer(props: DocumentPaneRenderProps) {
    return <IfcRendererPane active={props.active} src={props.src} />;
  };
}
